import { feature, useFeature } from '@/app/context';
import type { SnapshotFrom } from 'xstate';
import { filingcredentialMachine } from './filingcredential.machine';

export const useFilingcredentialRef = () => feature('filingcredential');
export const useFilingcredential = <R>(selector: (snapshot: SnapshotFrom<typeof filingcredentialMachine>) => R) =>
  useFeature('filingcredential', selector);
